import React from 'react';
import './css/Studios.css';
import bg1 from "../assets/studiobg1.png";
import bg2 from "../assets/studiobg2.png";
import { Link } from 'react-router-dom';

const Studios = () => {
    return (
        <section className='studio-main-div2'>
            <div className='studios-container-main'>
                <div className='studios-container-main-content1'>
                    <div className='studios-image-div1'>
                        <img src={bg1} alt="Dhiman Workshop"/>
                    </div>
                    <h1 className='studios-heading'>Our Workshop</h1>
                    <div className='studios-image-div2'>
                        <img src={bg2} alt="Woodworking Craftsmanship"/>
                    </div>
                </div>
                <div className='studios-container-main-content2'>
                    <h2 className='studios-heading-small'>
                        At Dhiman Wood Works, we collaborate closely with our clients to bring their vision to life. From initial design to final installation, we ensure each wooden masterpiece perfectly matches your requirements and exceeds expectations.
                    </h2>
                    <div className='studios-container-main-content2-content1-paras'>
                        <p className='paragraph'>
                            Founded by master craftsman Babu Ram Dhiman, our workshop combines traditional woodworking expertise with modern techniques. Our skilled team specializes in creating bespoke wooden furniture, custom cabinetry, and architectural woodwork for both residential and commercial spaces.

                            Each project benefits from our meticulous attention to detail, premium material selection, and innovative design approaches. Our workshop is equipped with state-of-the-art tools, allowing us to maintain the highest standards of craftsmanship while meeting contemporary design demands.
                        </p>
                        <Link to="/services">
                            <button className='button-89-2'>Explore Our Craft</button>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Studios;
